import React from 'react';
import { observer } from 'mobx-react';
import { Table } from 'antd';
import { TablePaginationConfig } from 'antd/es/table';
import { GroupOutlined } from '@ant-design/icons';
import { Catcher, LinkComponent, SkyPaginationTotal } from '../../';
import { CardLayout, cardLayoutOptions } from '../../Layout';
import { appConfig } from '../../../settings';
import { IColumnOptionComponent, ICountryTelecomUsage } from '../../../interfaces';
import { useCountryTelecomUsageTable } from '../../../hooks';
import { tF } from '../../../translate';

export const ShowCountryTelecomUsageTable: React.FC<IColumnOptionComponent> = observer(() => {
    const pageSize = appConfig.pageDefaultParams.includeViewPageSize;
    const list = useCountryTelecomUsageTable();
    const tableColumns = [
        {
            title: tF('Network'),
            dataIndex: 'name',
        },
        {
            title: tF('Usage'),
            dataIndex: 'usage',
        },
    ];

    const tableData = list.map((network: ICountryTelecomUsage) => ({
        key: network.id,
        name: (
            <span>
                <LinkComponent currentListComponent={'OperatorsList'} id={network.id} name={network.name} />
            </span>
        ),
        usage: <span>{network.usage}</span>,
    }));

    const pagination: false | TablePaginationConfig =
        pageSize > list.length
            ? false
            : {
                  total: list.length,
                  pageSize: pageSize,
                  className: 'customPagination',
                  showSizeChanger: false,
                  size: 'default',
                  showTotal: SkyPaginationTotal,
                  position: ['bottomLeft'],
              };

    return (
        <Catcher>
            <CardLayout
                columnOption={cardLayoutOptions.cardTableOperators}
                count={list.length}
                icon={<GroupOutlined />}
                idSpinners={['GET_USAGE_TELECOM_LIST', 'GET_OPERATOR_ACTIVITY']}
                isTable
                title={'Network Usage'}
            >
                <Table
                    dataSource={tableData}
                    columns={tableColumns}
                    pagination={pagination}
                    className={'table-theme'}
                    size={'small'}
                />
            </CardLayout>
        </Catcher>
    );
});
